import React from 'react';

import { bool, func, string } from 'prop-types';
import { Radio } from '@picsio/ui';

export default function RadioItem({
  value,
  label,
  checkedValue,
  disabled,
  onChange,
  onClick,
  labelDataTestId,
  ...restProps
}) {
  const handleClick = () => {
    if (disabled) {
      return;
    }

    onChange(value);
    onClick?.();
  };

  return (
    <div
      className={`radioListItem UIRadio ${disabled ? 'UIRadio--disabled' : ''}`}
      onClick={handleClick}
      {...restProps}
    >
      <Radio
        checked={checkedValue === value}
        disabled={disabled}
        onChange={() => {
        }}
      />
      {label && (
        <span className="UIRadio__label" data-testid={labelDataTestId}>{label}</span>
      )}
    </div>
  );
}

RadioItem.defaultProps = {
  label: '',
  disabled: false,
  labelDataTestId: '',
  onClick: undefined,
};

RadioItem.propTypes = {
  value: string.isRequired,
  label: string,
  checkedValue: string.isRequired,
  disabled: bool,
  onChange: func.isRequired,
  onClick: func,
  labelDataTestId: string,
};
